import { ADD_MEDICAMENTOS } from "./types";

export default (state = [], action) => {
  switch (action.type) {
    case ADD_MEDICAMENTOS:
      return action.payload;
    default:
      return state;
  }
};
